import { render, staticRenderFns } from "./permintaanPembatalan.vue?vue&type=template&id=298c4cfb&"
import script from "./permintaanPembatalan.vue?vue&type=script&lang=js&"
export * from "./permintaanPembatalan.vue?vue&type=script&lang=js&"
import style0 from "./permintaanPembatalan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports